export const showInformation = () => localStorage.getItem('showInformation') === 'true';
export const toggleInformation = (showInformation: boolean) => {
    localStorage.setItem('showInformation', JSON.stringify(showInformation));
    if (showInformation) {
        document.body.classList.add('information-on');
    } else {
        document.body.classList.remove('information-on');
    }
};
